module.exports = __webpack_public_path__ + "static/media/monitorsync.7c6abdfc.jpg";